import { useContext, useEffect, useRef, useState } from "react";
import { OrderContext } from "../ContextApi/context";

const TheMount = (props) => {

    const [order, setOrder] = useContext(OrderContext);

    const [currentMount, setCurrentMount] = useState(1);

    useEffect(() => {
        let theItm = order.Orders.findIndex(itm => itm.orderItemId == props.itemId);
        if (theItm != -1)
            setCurrentMount(order.Orders[theItm].mount);
    }, [order])


    const addToMount = () => {

        let theItm = order.Orders.findIndex(itm => itm.orderItemId == props.itemId);
        order.Orders[theItm].mount = parseInt(order.Orders[theItm].mount) + 1;
        setOrder({ ...order });
    }

    const lessToMount = () => {
        let theItm = order.Orders.findIndex(itm => itm.orderItemId == props.itemId);

        // Safety check - if item not found in order, don't proceed
        if (theItm === -1) {
            return;
        }

        // Decrease mount but never below 1
        if (order.Orders[theItm].mount > 1) {
            order.Orders[theItm].mount = parseInt(order.Orders[theItm].mount) - 1;
            setOrder({ ...order });
        }
    }

    return (
        !props.hideBtns ?
            <div className={"prodPlusMinus"}>
                {!props.hideBtns && <button type="button" className={"btnReset plusBtn"} aria-label="הוסף יחידה" onClick={() => addToMount()}>+</button>}
                <div className={!props.hideBtns && "mountNum"}>
                    {currentMount}
                </div>
                {!props.hideBtns && <button type="button" className={"btnReset minusBtn"} aria-label="הפחת יחידה" onClick={() => lessToMount()}>-</button>}
            </div>
            :
            <div>
                {currentMount}
            </div>
    );

}

export default TheMount;
